/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WidgetPublicCaptcha } from './WidgetPublicCaptcha';
import {
    WidgetPublicCaptchaFromJSON,
    WidgetPublicCaptchaFromJSONTyped,
    WidgetPublicCaptchaToJSON,
    WidgetPublicCaptchaToJSONTyped,
} from './WidgetPublicCaptcha';

/**
 * 
 * @export
 * @interface WidgetPublicConfig
 */
export interface WidgetPublicConfig {
    /**
     * 
     * @type {string}
     * @memberof WidgetPublicConfig
     */
    widgetName: string;
    /**
     * 
     * @type {WidgetPublicCaptcha}
     * @memberof WidgetPublicConfig
     */
    captcha: WidgetPublicCaptcha | null;
}

/**
 * Check if a given object implements the WidgetPublicConfig interface.
 */
export function instanceOfWidgetPublicConfig(value: object): value is WidgetPublicConfig {
    if (!('widgetName' in value) || value['widgetName'] === undefined) return false;
    if (!('captcha' in value) || value['captcha'] === undefined) return false;
    return true;
}

export function WidgetPublicConfigFromJSON(json: any): WidgetPublicConfig {
    return WidgetPublicConfigFromJSONTyped(json, false);
}

export function WidgetPublicConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetPublicConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'widgetName': json['widgetName'],
        'captcha': WidgetPublicCaptchaFromJSON(json['captcha']),
    };
}

export function WidgetPublicConfigToJSON(json: any): WidgetPublicConfig {
    return WidgetPublicConfigToJSONTyped(json, false);
}

export function WidgetPublicConfigToJSONTyped(value?: WidgetPublicConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'widgetName': value['widgetName'],
        'captcha': WidgetPublicCaptchaToJSON(value['captcha']),
    };
}

